import React from 'react'

const PrintDocumemtBody = ({ docInfo, docType }) => {
    return (
        <div className='prefaktor-print-body-container'>
            <table className='prefaktor-print-body-table'>
                <thead>
                    <tr>
                        <th>
                            ردیف
                        </th>
                        <th>
                            نام کالا
                        </th>
                        <th>
                            مقدار
                        </th>
                        <th>
                            توضیحات
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        docInfo.items.map((item, index) => {
                            return (
                                <tr>
                                    <td>
                                        {index + 1}
                                    </td>
                                    <td>
                                        {docType === "import" ? item.commodity?.name : item.second_commodity?.name || "- - -"}
                                    </td>
                                    <td>
                                        {docType === "import" ? item.count_im : item.count_ex || "- - -"}
                                    </td>
                                    <td>
                                        {item.description}
                                    </td>
                                </tr>
                            )
                        })
                    }
                    <tr>
                        <td colSpan={4} className="w-100 text-end p-1 pb-5 ">
                            <span >
                                توضیحات: 
                                {docInfo.description}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div >

    )
}

export default PrintDocumemtBody